import React from 'react'
import {connect} from 'react-redux'
import {saveTest,deleteTest,updateRouteBolts,saveComment,deleteComment} from '../actions'
import HandsonTable from '../components/HandsonTable'
import DatePicker from 'material-ui/DatePicker'
import RaisedButton from 'material-ui/RaisedButton'
import {MarkerList} from '../config'

import {parseBoltData} from '../utils/table'
import {BoltKeyMap} from '../utils/bolt'

import {processBolt} from '../utils/bolt'

const BoltIdSource = [...MarkerList,'']
const BoltTypeSource = Object.keys(BoltKeyMap).map(key=>BoltKeyMap[key])

const LogbookTest = React.createClass({
  displayName: 'LogbookTest',
  nestedHeaders: [
  ['','','','','',{ label: '不合格', colspan: 6 },''],
  ['編號','路線','Bolt','Bolt類型','合格','拉力kN','直接斷裂','拉力下降','位移超標','外觀異常','膠異常',,'測試人員'],
  ],
  columns: [
  { data: 'rid', width:60},
  { data: 'name', readOnly: true,width:100},
  { data: 'bid', width:60, type: 'dropdown', source: BoltIdSource},
  { data: 'type',  width:150, type: 'dropdown', source:BoltTypeSource},
  { data: 'ok', type: 'checkbox', width:100},
  { data: 'strength', type: 'numeric', width:100},
  { data: 'brk', type: 'checkbox', width:100},
  { data: 'drop', type: 'checkbox', width:100},
  { data: 'deform', type: 'checkbox', width:100},
  { data: 'crack', type: 'checkbox', width:100},
  { data: 'glue', type: 'checkbox', width:100},
  { data: 'tester', width:200},
  ],
  pending:[],
  getInitialState() {
    let date = yyyymmdd(new Date())
    let list = this.getList(date) || [{}]
    return {
      autoLoad: {},
      list,
      date,
    }
  },

  componentWillReceiveProps(nextProps) {
    if(!this.editing) {
      let list = this.getList(this.state.date,nextProps)|| [{}]
      this.setState({list})
    }
  },
  afterChange(data,index){
    this.editing = true
    let {rid,bid,type} = data
    // let {context,timestamp} = comment
    // console.log('afterChange',data)
    let {list,autoLoad} = this.state
    let {routes} = this.props
    let {bolts,name} = routes[rid] || {}
    list = [...list]
    let needAddNew = false
    if(index === (list.length -1))
      needAddNew = true
    if(bolts && rid &&!bid &&!autoLoad[rid]) {
      autoLoad[rid] = true
      list = list.filter(test=>(test.rid!==rid && (test.rid ||test.bid)))
      Object.keys(bolts).forEach(bid=>{
        let {name:type}=parseBoltData(bolts[bid])
        list.push({rid,bid,type,name})
      })
      needAddNew = true
    }
    if(needAddNew){
      list.push({})
      this.setState({list,autoLoad})
    }

    if(!rid){
      if(this.timer)
        clearTimeout(this.timer)

      this.timer = setTimeout(()=>{
        list = this.state.list.filter(test=>(!!test.rid))
        list.push({})
        this.setState({list})
      },1000)
    }
    // console.log(rid,list,autoLoad)

  },
  getList(date,props){
    let {routes} = props || this.props
    let {tests} = props || this.props
    tests = tests[date]
    if(!tests)
      return null
    let list = Object.keys(tests).map(id=>{
      let test = {...tests[id]}
      test.type = BoltKeyMap[test.type]
      test.name = routes[test.rid].name
      return test
    })
    list.push({})
    return list
  },
  onChangeDate(e,date){
    date = yyyymmdd(date)
    this.setState({date})

    let list = this.getList(date)
    list && this.setState({list})
  },

  doSave(){
    let {routes,comments} = this.props
    let {date,list} = this.state
    let pendingRoutes = {}
    let reportRoutes = {}

    deleteTest(date)
    list.forEach(test=>{
      let {ok,brk,drop,deform,crack,glue,type,strength,rid,bid} = test
      let route = pendingRoutes[rid] || {...routes[rid]}
      test = {...test}

      if(!ok && !brk && !drop && !deform && !crack && !glue)
        return

      reportRoutes[rid] = reportRoutes[rid] || {ok:0,nok:0,aok:0,anok:0}
      if(bid ==='A01' || bid === 'A02') {
        if(ok)
          reportRoutes[rid].aok ++
        else
          reportRoutes[rid].anok ++
      } else {
        if(ok)
          reportRoutes[rid].ok ++
        else
          reportRoutes[rid].nok ++
      }


      if(!ok) delete test.ok
      if(!brk) delete test.brk
      if(!drop) delete test.drop
      if(!deform) delete test.deform
      if(!crack) delete test.crack
      if(!glue) delete test.glue
      if(!strength) delete test.strength
      test.type = Object.keys(BoltKeyMap).filter(key=>BoltKeyMap[key]===type)[0]
      delete test.name

      let bolt = route.bolts[bid] || ''
      bolt = bolt.split('\n')[0]
      let {year} = processBolt(bolt)
      bolt = test.type + (year ? ('_'+bolt.split('_')[1]) : '') +'\n'
      if(ok) {
        bolt += '8kN OK\n'
      } else if(glue){
        bolt += '8kN OUT\n'
      } else if(brk){
        bolt += strength+'kN BRK\n'
      } else {
        bolt += strength+'kN BAD\n'
      }
      bolt += date

      route.bolts[bid] = bolt

      pendingRoutes[rid] = route
      console.log('saveTest',test,bolt)
      saveTest(date,test)

    })

    Object.keys(pendingRoutes).forEach(rid=>{
      let route = pendingRoutes[rid]
      updateRouteBolts(route)
      console.log('saveRoute',route)
    })


    let report = `[${date}] 拉力測試報告\n`
    Object.keys(reportRoutes).forEach(rid=>{
      let {aok,anok,ok,nok} = reportRoutes[rid]
      let {name} = routes[rid]
      report += `#${rid} ${name} `
      if(aok || anok) {
        report += 'Anchor '
        if(aok)
          report += `${aok}顆合格`
        if(aok&&anok)
          report += `，`
        if(anok)
          report += `${anok}顆不合格`
        if(ok&&nok)
          report += `/`
      }

      if(ok || nok) {
        report += 'Leading Bolt '
        if(ok)
          report += `${ok}顆合格`
        if(ok&&nok)
          report += `，`
        if(nok)
          report += `${nok}顆不合格`
      }
      report += `\n`

    })

    comments = comments['0'] || {}
    let comment = {}
    Object.keys(comments).forEach(id=>{
      if(comments[id].testDate ===date){
        comment = comments[id]
        console.log('comment',comment)
      }
    })

    let {timestamp} = comment
    if(Object.keys(reportRoutes).length) {
      console.log('report',report,timestamp)
      saveComment({
        uid:'facebook:1712521529024091',
        name:'Re-bolt Team',
        routeId:'0',
        timestamp,
        testDate:date,
        context:report,
      })
    } else {
      if(timestamp) {
        deleteComment({routeId:'0',timestamp})
      }
    }



    // console.log('onSave',date,list)
  },

  onSave(){
    if(window.confirm('確定送出?')){
      this.doSave()
    }
  },
  render() {
    let styles = {
      date:{
        margin:20,
        marginBottom:0,
        display: 'inline-block',

      },
      table:{
        margin:20,
        overflow:'auto',
        height:'100%',
      },
      button: {

      }
    }

    return (
      <div>
      <DatePicker
      style={styles.date}
      id="testDate"
      defaultDate={new Date()}
      maxDate={new Date()}
      onChange={this.onChangeDate}/>
      <RaisedButton
      label="送出"
      primary={true}
      disabled={this.state.disabled}
      onTouchTap={this.onSave}
      style={styles.button} />

      <HandsonTable
      ref="table"
      style={styles.table}
      noSorting={true}
      nestedHeaders={this.nestedHeaders}
      columns={this.columns}
      autoUpdate={true}
      data={this.state.list}
      afterChange={this.afterChange}/>
      </div>
      )
  },
})

function mapStateToProps(state,props) {
  let { comments,routes,tests } = state

  return {tests,routes,comments}
}


export default connect(mapStateToProps)(LogbookTest)



/** WEBPACK FOOTER **
 ** ./src/app/containers/LogbookTest.js
 **/